import { render, staticRenderFns } from "./diff_stats_dropdown.vue?vue&type=template&id=49816d56&scoped=true&vue3"
import script from "./diff_stats_dropdown.vue?vue&type=script&lang=js&vue3"
export * from "./diff_stats_dropdown.vue?vue&type=script&lang=js&vue3"
import style0 from "./diff_stats_dropdown.vue?vue&type=style&index=0&id=49816d56&prod&scoped=true&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49816d56",
  null
  
)

export default component.exports